import { Text, usePublicPagePopupsContext } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { Container, StyledLeftArrow, StyledLink } from "./styles";

interface Props {
  to: string;
}

const SecondaryBackButton: React.FC<Props> = ({ to }) => {
  const { t } = useTranslation();
  const { paddingTop, animationDuration } = usePublicPagePopupsContext();

  return (
    <Container
      extraPaddingTop={paddingTop}
      extraPaddingTopAnimationDuration={animationDuration}
    >
      <StyledLink to={to}>
        <StyledLeftArrow />
        <Text color="quaternary" variant="body8">
          {t("9") /* Voltar */}
        </Text>
      </StyledLink>
    </Container>
  );
};

export default SecondaryBackButton;
